import * as types from './types';
import {
  SchoolAdminToolBookStatementCreateOrChangeModel,//创建/编辑结算单
  SchoolAdminToolBookStatementListModel,//结算批次列表
  AdminToolBookStatementDeleteModel,//结算批次删除
  PublisherToolBookStatementArchiveModel,//批次归档
} from 'src/model/index';
import {
  extend,
  findIndex
} from 'lodash';

export default{

  //结算批次列表
  actionGetToolBookStatementList({commit,state},query){
    if (state.toolBookStatementList.state === 'loading'){
      return Promise.reject();
    }
    commit(types.ACTION_GET_TOOL_BOOK_STATEMENT_LIST, {
      state: 'loading'
    });
    return SchoolAdminToolBookStatementListModel.getInstance().execute(query).then(function(response){
      commit(types.ACTION_GET_TOOL_BOOK_STATEMENT_LIST, {
        state: 'loadend',
        list: response.list,
        total: response.total
      });
      return response;
    }).catch(function(err){
      commit(types.ACTION_GET_TOOL_BOOK_STATEMENT_LIST, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    })
  },
  //创建/编辑结算单
  actionToolBookStatementCreateOrChange({commit},query){
    return SchoolAdminToolBookStatementCreateOrChangeModel.getInstance().execute(query)
  },
  actionAdminToolBookStatementDeleteModel({commit},query){
    return AdminToolBookStatementDeleteModel.getInstance().execute(query)
  },
  //归档
  actionAdminToolBookStatementPigeonholeModel({commit},query){
    return PublisherToolBookStatementArchiveModel.getInstance().execute(query)
  }
}






// WEBPACK FOOTER //
// ./src/store/Admin/modules/semesterListIndex/actions.js